function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.96341346,11.5 C5.96341346,14.5530288 8.44697115,17.0365865 11.5,17.0365865 C14.5530288,17.0365865 17.0365865,14.5530288 17.0365865,11.5 C17.0365865,8.44697115 14.5530288,5.96341346 11.5,5.96341346 C8.44697115,5.96341346 5.96341346,8.44697115 5.96341346,11.5 Z M11.5,8.17495192 C13.3333654,8.17495192 14.8250481,9.66663462 14.8250481,11.5 C14.8250481,13.3333654 13.3333654,14.8250481 11.5,14.8250481 C9.66663462,14.8250481 8.17495192,13.3333654 8.17495192,11.5 C8.17495192,9.66663462 9.66663462,8.17495192 11.5,8.17495192 Z M10.3920192,19.2403846 L12.6035577,19.2403846 L12.6035577,22.5576923 L10.3920192,22.5576923 L10.3920192,19.2403846 Z M10.3920192,0.442307692 L12.6035577,0.442307692 L12.6035577,3.75961538 L10.3920192,3.75961538 L10.3920192,0.442307692 Z M0.440096154,10.3942308 L3.75740385,10.3942308 L3.75740385,12.6057692 L0.440096154,12.6057692 L0.440096154,10.3942308 Z M19.2381731,10.3942308 L22.5554808,10.3942308 L22.5554808,12.6057692 L19.2381731,12.6057692 L19.2381731,10.3942308 Z",
  id: "Icon-Shape"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "2.89600962 18.5360096 5.24024038 16.1895673 6.80490385 17.753125 4.46067308 20.0995673"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "16.1884615 5.24576923 18.5349038 2.89932692 20.0984615 4.46288462 17.7520192 6.80932692"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "5.24355769 6.81043269 2.89711538 4.46399038 4.46177885 2.90043269 6.80600962 5.246875"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "20.0984615 18.5371154 18.5349038 20.1006731 16.1884615 17.7542308 17.7520192 16.1906731"
});

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    strokeWidth: 1,
    fill: "#000000",
    fillRule: "nonzero",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.cf4347b9.svg";
export { ForwardRef as ReactComponent };